<template>
  <div class="">
    <div id="imagem" class="bg-fixo"></div>
    <div class="container-xxl">
      <div class="row">
        <div class="col-12 text-end base_conteudo sticky-top">
          <button @click="$router.go(-1)" class="btn btn-sm btn-dark">Voltar</button>
        </div>
        <div class="col-md-8 col-lg-9 col-xl-9">
          <div id="titulo_noticia_view" class="base_conteudo col-12 text-center" @click="listar_dados()">{{
            listagem.titulo }}</div>
          <propaganda nome_exibicao="Topo da noticia"></propaganda>
          <youtube autoplay="0" :ativa_placeholder="ativa_placeholder" :link="listagem.link_video"></youtube>
          <div id="corpo" class="base_conteudo col-md-12" v-html="listagem.corpo">
          </div>
          <div class="row base_small">
            <div id="data_criacao" class="base_conteudo col-6"><small>Data da notícia: {{ listagem.data_criacao
            }}</small>
            </div>
            <div id="redator" class="base_conteudo col-6 text-end">Autor: {{ listagem.redator }}</div>
          </div>
          <div id="link_referencia" class="base_conteudo alert alert-dark text-white"
            v-if="listagem.link_referencia != ''">
            Fonte: <a class="btn btn-default" :href="listagem.link_referencia" target="_blank">{{
              listagem.link_referencia
            }}</a>
          </div>
          <NoticiasReferencia></NoticiasReferencia>
        </div>
        <div class="col-md-4 col-lg-3 col-xl-3 mp-3">
          <div class="w-100 text-center rounded bg-primary text-white p-3" v-if="true">Anúncios</div>
          <br><br>
          <propaganda altura="300" nome_exibicao="Lateral 1"></propaganda>
          <propaganda altura="300" nome_exibicao="Lateral 2"></propaganda>
          <propaganda altura="300" nome_exibicao="Lateral 3"></propaganda>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/api';
import { filtro_loading, muda_titulo } from '@/assets/js/functions'
import Youtube from './Youtube.vue';
import Propaganda from './propaganda.vue';
import NoticiasReferencia from './NoticiasReferencia.vue';
export default {
  name: 'ViewNoticia',
  components: { Youtube, Propaganda },
  data() {
    return {
      link: this.$route.params.link,
      listagem: {
        titulo: '',
        link_video: '',
        imagem: '',
        corpo: '',
        data_criacao: '',
        redator: '',
        link_referencia: '',
        categoria_real: '',
      },
      imagem_montada: '',
    }
  },
  methods: {
    async listar_dados() {
      filtro_loading()
      this.listagem = await api.post('news/list_site/' + this.link)
      const metaInfo = {
        title: this.listagem.titulo,
        meta: [
          { name: 'og:image', content: process.env.VUE_APP_site + '/' + this.listagem.imagem },
          { name: 'og:title', content: this.listagem.titulo + ' | Notícia - ' + process.env.VUE_APP_nome_site },
          { name: 'og:description', content: (this.listagem.breve_descricao.length > 0 ? this.listagem.breve_descricao : this.listagem.titulo) },
          { name: 'og:url', content: process.env.VUE_APP_site + '/noticias/lnk/' + this.link },
        ]
      }

      muda_titulo(metaInfo);

      var img = (this.listagem.imagem == '' ? '/img/quemsomos.jpg' : '/img/news/' + this.listagem.imagem)
      this.imagem_montada = 'url("' + img + '")'
      filtro_loading(false)
    }
  },
  created() {
    this.listar_dados()
  },
  mounted() {

  },
}
</script>

<style>
.ck {
  z-index: 9999 !important;
}

#imagem {
  width: 100%;
  height: 66vh !important;
  background-color: var(--cor-base-fundo-transp);
}

#imagem::before {
  /* background-image: url('/public/img/quemsomos.jpg'); */
  background-image: v-bind(imagem_montada);
  height: 65.5vh !important;
}

#corpo>p>img {
  border: 0px solid red !important;
  max-width: 90% !important;
}

.base_conteudo {
  padding: 10px;
  font-family: 'Poppins';
}

.base_small {
  font-size: .8rem;
  color: #999;
}

#titulo_noticia_view {
  font-size: 2.3rem;
  font-weight: bold;
}
</style>